// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8f3d82e4","453":"7c25b810","732":"6bc85660","977":"a2406095"}[chunkId] + ".chunk.js";
};